import { render, staticRenderFns } from "./GeneralJobUpdate.vue?vue&type=template&id=2f266590&"
import script from "./GeneralJobUpdate.vue?vue&type=script&lang=js&"
export * from "./GeneralJobUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports